import React from 'react'
import { Element } from 'react-scroll'
import SectionTitle2 from '../../sectionTitle/SectionTitle2'

const AISolutions = () => {
  return (
    <>
      <Element
        name="AISolutions"
        className="datatalent-section-gap bg-white"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center"
                title = "Key Focus Areas"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center section-description">We bring Edge AI directly to the plant floor, enabling decentralized processing, minimal latency, and always-on reliability-ideal for harsh, energy-intensive, or mission-critical environments.</p>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/gear.svg`} alt="gear" />
                </div>
                <h5 className="mt-3 mb-3">Predictive Maintenance & Fault Detection</h5>
                <p className="mb-0">Time-series and sensor fusion models for early failure detection in turbines, pumps, HVACs, and other critical assets.</p>
              </div>  
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/eye.svg`} alt="eye" />
                </div>
                <h5 className="mt-3 mb-3">Energy Efficiency Optimization</h5>
                <p className="mb-0">AI-driven tools to analyze equipment usage, reduce wastage, and forecast consumption across factory operations.</p>
              </div>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/no-axis-columns-increasing.svg`} alt="no-axis-columns-increasing" />
                </div>
                <h5 className="mt-3 mb-3">Smart Microgrid Monitoring & Hydrogen Systems</h5>
                <p className="mb-0">ML algorithms for system-level performance optimization, predictive maintenance, and production scheduling for green hydrogen and energy-intensive systems.</p>
              </div>  
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/spark.svg`} alt="spark" />
                </div>
                <h5 className="mt-3 mb-3">Vehicle-to-Grid (V2G) Optimization</h5>
                <p className="mb-0">AI-based forecasting for bi-directional energy scheduling, charging optimization, and real-time energy flow prediction for connected EV assets.</p>
              </div>  
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/chart.svg`} alt="chart" />
                </div>
                <h5 className="mt-3 mb-3">Factory Floor Anomaly Detection</h5>
                <p className="mb-0">Embedded Edge AI agents to track vibration, temperature, and acoustic patterns for real-time alerts.</p>
              </div>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/shield-check.svg`} alt="shield-check" />
                </div>
                <h5 className="mt-3 mb-3">Digital Twin & Dashboards</h5>
                <p className="mb-0">Visualization platforms for live model insights, system health diagnostics, and AI feedback loops.</p>
              </div>  
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default AISolutions;